// extracted by mini-css-extract-plugin
export default {"container":"GoogleSignInButton_container__6KQqa","icon":"GoogleSignInButton_icon__KF+qE","button":"GoogleSignInButton_button__6hlMj"};